.image {
  display: block;
  width: 100%;
  height: 100%;

  img {
    max-width: var(--wix-img-max-width, 100%);
  }

  &[data-animate-blur] img {
    filter: blur(9px);
    transition: filter 0.8s ease-in;

    &[data-load-done] {
      filter: none;
    }
  }
}
